import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SearchBlockRHF from "../../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import EditableTableForKnoweledgeTest from "../../../../components/knowledgeTestComponents/commonComponents/EditableTableForKnoweledgeTest/EditableTableForKnoweledgeTest";

import { columnsListenerTable } from "./columnsForTable";

import {
  getDataSearchListenerBySearchParams,
  updateListenerTableData,
} from "../../../../redux/searchListenerReducer/actionSearchListenerReducer";
import { ADD_LISTENER_EXPULSION_ORDER_TABLE } from "../../../../redux/types";

import { options, setOptionsSections } from "../../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./searchListener.module.css";

function SearchListener() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dataForTable } = useSelector((state) => state.searchListenerReducer);
  const { gimsSections } = useSelector((state) => state.dictionaryReducer);
  const { programId, orderDate } = useSelector((state) => state.expulsionOrderReducer);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    startDate: "",
    endDate: "",
    section: 0,
    programId,
    orderDate,
  });

  const handleTableDataUpdate = (newData) => {
    dispatch(updateListenerTableData(newData)); // Вызываем действие для обновления данных через Redux
  };

  const handleCloseApp = () => {
    navigate(-1);
  };

  const handleAddListener = () => {
    const data = dataForTable.filter((el) => el.checked);
    dispatch({
      type: ADD_LISTENER_EXPULSION_ORDER_TABLE,
      data: data,
    });
    navigate(-1);
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({ ...searchParams, [e.target.dataset.id]: e.target.value });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    dispatch(getDataSearchListenerBySearchParams(searchParams));
  };

  const handleClear = () => {
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        startDate: "",
        endDate: "",
        section: 0,
        programId,
        orderDate,
      }),
    );
    dispatch(
      getDataSearchListenerBySearchParams({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        startDate: "",
        endDate: "",
        section: 0,
        programId,
        orderDate,
      }),
    );
  };
  useEffect(() => {
    dispatch(getDataSearchListenerBySearchParams(searchParams));
  }, [programId, orderDate]);

  useEffect(() => {
    if (gimsSections.length > 0) {
      setOptionsSections(gimsSections, options.inputsSearchListener.key);
    }
  }, [gimsSections]);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsSearchListener}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <EditableTableForKnoweledgeTest
        mode={"add"}
        handleTableDataUpdate={handleTableDataUpdate}
        columns={columnsListenerTable}
        tableData={dataForTable}
        caption={"Результат поиска"}
      />
      <div className={styles["buttons-block"]}>
        <button
          className={styles["close-btn"]}
          onClick={() => {
            handleCloseApp();
          }}>
          Закрыть
        </button>
        <button
          className={styles["save-btn"]}
          onClick={(e) => handleAddListener(e)}>
          Добавить
        </button>
      </div>
    </div>
  );
}

export default SearchListener;
